// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"16914118","879":"7e2c226e"}[chunkId] + ".chunk.js";
};